

export const blockMessage = ['provide_email', 'provide_phone_number']